module.exports = __webpack_public_path__ + "img/logo-2.310b4cd3.png";